exports.default = {
  'title': 'Assets',
  'files_count': '{count} files',
  'folder_unit': 'folders',
  'all_assets': 'All assets',
  'folder': 'Folder',
  'default_space': 'Default space',
  'new_folder': 'New folder',
  'create_folder_hint': 'Keep your assets organized',
  'folder_actions': 'Folder actions',
  'add_content': 'Add content',
  'upload_file': 'Upload file',
  'upload_image_video': 'Upload image/video',
  'unsupported_upload_type': '“{name}” is not a supported image or video format and was skipped',
  'upload_to': 'Upload to',
  'selected_folder': 'Selected location',
  'upload_folder_search': 'Search folders',
  'no_folder_match': 'No matching folders',
  'choose_upload_folder': 'Choose an upload folder',
  'uploading': 'Uploading',
  'upload_waiting': 'Waiting',
  'upload_complete': 'Uploaded',
  'upload_failed': 'Upload failed',
  'upload_success': 'Upload complete',
  'upload_partial': '{count} files failed to upload',
  'batch_operation': 'Bulk actions',
  'exit_batch': 'Exit bulk actions',
  'selected_assets': 'assets selected',
  'batch_limit': 'Select up to {count} assets at a time',
  'batch_download': 'Download',
  'batch_download_success': 'Started downloading {count} files',
  'batch_download_partial': 'Started {success} downloads; {failed} failed',
  'download_started': 'Download started',
  'download': 'Download',
  'preview': 'Preview',
  'preview_unavailable': 'This file cannot be previewed online',
  'loading_preview': 'Preparing preview',
  'preview_back': 'Back to folder',
  'preview_failed': 'Preview could not load. Retry or download the file.',
  'preview_retry': 'Reload',
  'more_actions': 'More actions',
  'rename': 'Rename',
  'delete': 'Delete',
  'move': 'Move',
  'refresh': 'Refresh',
  'loading_more': 'Loading more...',
  'search': 'Search',
  'filter': 'Filters',
  'keyword_placeholder': 'Search by keyword',
  'type_filter': 'Filter by type',
  'type_all': 'All types',
  'type_image': 'Images',
  'type_video': 'Videos',
  'type_audio': 'Audio',
  'type_other': 'Other',
  'date_filter': 'Filter by date',
  'filter_date': 'Filter dates',
  'filter_date_hint': 'Filter assets by creation time',
  'date_all': 'Any time',
  'date_today': 'Today',
  'date_recent_5': 'Last 5 days',
  'date_recent_15': 'Last 15 days',
  'date_recent_30': 'Last 30 days',
  'custom_date': 'Custom range',
  'start_date': 'Start date',
  'end_date': 'End date',
  'reset': 'Reset',
  'apply': 'Apply',
  'sort_by_update': 'Sort by update time',
  'newest_first': 'Recently updated',
  'oldest_first': 'Oldest first',
  'no_assets': 'No assets here yet',
  'no_filter_results': 'No matching assets',
  'try_other_filters': 'Try changing the filters',
  'upload_to_start': 'Uploaded files will appear here',
  'folder_name': 'Folder name',
  'folder_name_placeholder': 'Enter a folder name',
  'folder_name_required': 'Enter a folder name',
  'folder_unavailable': 'This folder is unavailable or has been deleted',
  'rename_folder': 'Rename folder',
  'delete_folder': 'Delete folder',
  'confirm_delete_folder': 'Delete “{name}”?',
  'folder_not_empty': 'This folder contains {count} files. Choose what to do with them.',
  'delete_folder_files': 'Delete the files and folder',
  'move_folder_files': 'Move the files, then delete the folder',
  'confirm_delete': 'Delete',
  'move_assets': 'Move assets',
  'move_assets_count': 'Move {count} assets to:',
  'target_folder': 'Choose a target folder',
  'rename_file': 'Rename file',
  'file_name': 'File name',
  'file_name_required': 'Enter a file name',
  'confirm_delete_asset': 'Delete “{name}”?',
  'confirm_delete_selected': 'Delete the {count} selected assets?',
  'file_too_large': '“{name}” exceeds 50 MB and was skipped',
  'image_file_too_large': 'Image “{name}” exceeds 20 MB and was skipped',
  'operation_success': 'Operation complete',
  'operation_failed': 'Operation failed. Try again later.',
  'load_failed': 'Could not load assets. Try again later.',
  'total_items': '{count} items total',
  'visibility': 'Visibility',
  'visibility_private': 'Private',
  'visibility_team': 'Shared with team',
  'change_visibility_confirm': 'Change visibility to “{visibility}”?'
}
